import React, { useState } from 'react'
import { Formik, Form, FormikHelpers, FieldArray } from 'formik'
import { ContactFormSubmitterDetails } from "../contactUs/ConfactFormSubmitterDetails"
import ContactFormMessage from "../contactUs/ContactFormMessage"
import ArrowButton from "../ArrowButton"
import styles from '../../styles/careers/ApplyToPositionForm.module.css'
import contactStyles from '../../styles/ContactForm.module.css'
import * as Yup from 'yup'
import FSDialog from '../FSDialog'
import CheckMarkIcon from '../svg/CheckMarkIcon'

export interface Props {
  questions: string[]
  onFormSubmit?: (values: ContactValues, helpers: FormikHelpers<ContactValues>) => void;
}

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required('Required'),
  lastName: Yup.string().required('Required'),
  email: Yup.string().required('Required').email('Please enter a valid email address'),
  subject: Yup.string(),
  message: Yup.string(),
  phone: Yup.string(),
  questions: Yup.array().of(
    Yup.object().shape({
      answer: Yup.string()
    })
  )
})

export interface ContactValues {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  questions: Array<{answer: string}>; // optional field for extra questions
}

export const ApplyToPositionForm = ({ questions, onFormSubmit }: Props): JSX.Element => {
    const [ open, setOpen ] = useState(false)
  
  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    questions: questions.map(() => ({ answer: '' }))
  }

  const submit = async (
  values: ContactValues,
  { resetForm }: FormikHelpers<ContactValues>
) => {
  const data = new FormData()
  Object.keys(values).forEach((key) => {
    if (key === 'questions') {
      values[key].forEach((question: { answer: string }, index: number) => {
        data.append(questions[index], question.answer)
      })
    } else {
      data.append(key, values[key as keyof ContactValues])
    }
  })
  // @ts-ignore
  const res = await window.fetch('https://getform.io/f/aronxnpb', {
    method: 'post',
    body: data,
    dataType: 'json',
    headers: {
      "Accept": "application/json"
    },
    mode: 'cors',
  })
  if (res.status === 200) {
    resetForm()
    if (setOpen) setOpen(true)
  } else {
    // error handling?
  }
}

  const handleThanksClose = () => {
    setOpen(false)
  }

  return (
    <section>
    <Formik initialValues={initialValues} onSubmit={submit} validationSchema={validationSchema}>
      {({ handleSubmit }) => (
        <Form>
          <ContactFormSubmitterDetails lastField="phone" lastFieldLabel="Phone Number" lastFieldRequired={false} dark />
          <FieldArray name="questions">
            {() =>
              questions.map((question: string, index: number) => (
                <div key={question} className={styles.fieldContainer}>
                  <label>{question}</label>
                  <ContactFormMessage light fieldName={`questions.${index}.answer`} />
                </div>
              ))
            }
          </FieldArray>
          <div className={styles.actionButtonContainer}>
            <ArrowButton handleClick={handleSubmit}>Send it</ArrowButton>
          </div>
        </Form>
      )}
    </Formik>
          <FSDialog open={ open } handleClose={ handleThanksClose }
                withClose={ false } closeOnClick>
        <div className={ contactStyles.thanksContainer }>
          <h2 className={ contactStyles.thanksHeader }>Thanks for reaching out!</h2>
          <p className={ contactStyles.thanksBody }>We’ll get back to you when we’ve
            found our computer.</p>
          <CheckMarkIcon className={ contactStyles.check }/>
        </div>
      </FSDialog>
      </section>
  )
}